export class DeviceInfo {

  public deviceProtoVer   : string;
  public deviceAppliVer   : string;
  public deviceModel      : string;
  public devicePlatform   : string;
  public deviceUuid       : string;
  public deviceVersion    : string;

  

  constructor();

  constructor(
    deviceAppliVer : string,
  );

  constructor(deviceAppliVer?: string) {
    this.deviceAppliVer = deviceAppliVer;
  }

}
